<div class="container-fluid p-4">
  <div *ngIf="isInitializing || isRedirectingToLogin" class="text-center p-4">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2"><em>{{ isRedirectingToLogin ? 'Redirecting to sign in...' : 'Authenticating...' }}</em></p>
  </div>

  <div *ngIf="showError" class="alert alert-danger">
    <h4>Error</h4>
    <p>An error occurred during authentication. Please try refreshing the page.</p>
  </div>

  <div *ngIf="!isInitializing && !showError && !userContextIsAgVantisUser && !userContextSourceId" class="alert alert-warning">
    <h4>Unable to determine association</h4>
    <p>Your account does not have an associated source ID. Please contact your administrator.</p>
  </div>

  <div *ngIf="!isInitializing && !showError && redirectTo && !hasNavigated" class="text-center p-4">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2"><em>Redirecting...</em></p>
  </div>

  <div *ngIf="!isInitializing && !showError && !redirectTo" class="alert alert-info">
    <h4>Welcome</h4>
    <p>Use the navigation menu to access the different sections.</p>
  </div>
</div>

